import {Address, AttorneyData, DataPersonalSellerPf, Payment} from "../shared/models/SellerPf.model";

export function mapFormToDataPersonalSellerPfOne(formValue: any): Partial<DataPersonalSellerPf> {
  const deliveryAddress: Address = {
    isLocale: formValue.deliveryAddress_isLocale,
    zipCode: formValue.deliveryAddress_zipCode,
    street: formValue.deliveryAddress_street,
    number: formValue.deliveryAddress_number,
    complement: formValue.deliveryAddress_complement,
    district: formValue.deliveryAddress_district,
    city: formValue.deliveryAddress_city,
    state: formValue.deliveryAddress_state,
  };

  const attorneyData: AttorneyData = {
    useAttorney: formValue.attorneyData_useAttorney,
    fullName: formValue.attorneyData_fullName,
    documentNumber: formValue.attorneyData_documentNumber,
    email: formValue.attorneyData_email,
    phone: formValue.attorneyData_phone,
  };

  return {
    name: formValue.name,
    documentNumber: formValue.documentNumber,
    birth: {
      date: formValue.birth_date,
      nationality: formValue.birth_nationality,
      state: formValue.birth_state,
      city: formValue.birth_city,
    },
    gender: formValue.gender,
    profession: formValue.profession,
    hasDeclaration: formValue.hasDeclaration,
    relationship: {
      maritalStatus: formValue.relationship_maritalStatus,
      marriageDate: formValue.relationship_marriageDate,
      hasPartInSale: formValue.relationship_hasPartInSale,
      hasStableUnion: formValue.relationship_hasStableUnion,
      propertyRegime: formValue.relationship_propertyRegime,
    },
    document: {
      type: formValue.document_type,
      number: formValue.document_number,
      issueDate: formValue.document_issueDate,
      issuingAuthority: formValue.document_issuingAuthority,
      issuingAuthorityState: formValue.document_issuingAuthorityState,
    },
    parentage: {
      motherName: formValue.parentage_motherName,
      fatherName: formValue.parentage_fatherName,
    },
    contact: {
      email: formValue.contact_email,
      phone: formValue.contact_phone,
    },
    address: {
      zipCode: formValue.address_zipCode,
      street: formValue.address_street,
      number: formValue.address_number,
      complement: formValue.address_complement,
      district: formValue.address_district,
      city: formValue.address_city,
      state: formValue.address_state,
    },
    ...(isFilled(deliveryAddress) ? {deliveryAddress} : {}),
    ...(isFilled(attorneyData) ? {attorneyData} : {}),
    additionalInformation: {
      hasEmployee: formValue.additionalInformation_hasEmployee,
      isSellingToFamily: formValue.additionalInformation_isSellingToFamily,
      isUnderAge: formValue.additionalInformation_isUnderAge,
      situation: formValue.additionalInformation_situation,
    }
  }
}

export function mapFormToDataPersonalSellerPfTwo(formValue: any): Partial<DataPersonalSellerPf> {
  const deliveryAddress: Address = {
    isLocale: formValue.partner_deliveryAddress_isLocale,
    zipCode: formValue.partner_deliveryAddress_zipCode,
    street: formValue.partner_deliveryAddress_street,
    number: formValue.partner_deliveryAddress_number,
    complement: formValue.partner_deliveryAddress_complement,
    district: formValue.partner_deliveryAddress_district,
    city: formValue.partner_deliveryAddress_city,
    state: formValue.partner_deliveryAddress_state,
  };

  const attorneyData: AttorneyData = {
    useAttorney: formValue.partner_attorneyData_useAttorney,
    fullName: formValue.partner_attorneyData_fullName,
    documentNumber: formValue.partner_attorneyData_documentNumber,
    email: formValue.partner_attorneyData_email,
    phone: formValue.partner_attorneyData_phone,
  };

  const payment: Payment = {
    accountType: formValue.partner_payment_accountType,
    bankNumber: formValue.partner_payment_bankNumber,
    agencyNumber: formValue.partner_payment_agencyNumber,
    accountNumber: formValue.partner_payment_accountNumber
  };

  return {
    partner: {
      name: formValue.partner_name,
      cpf: formValue.partner_cpf,
      gender: formValue.partner_gender,
      profession: formValue.partner_profession,
      birth: {
        date: formValue.partner_birth_date,
        state: formValue.partner_birth_state,
        city: formValue.partner_birth_city,
        nationality: formValue.partner_birth_nationality,
      },
      document: {
        type: formValue.partner_document_type,
        number: formValue.partner_document_number,
        issueDate: formValue.partner_document_issueDate,
        issuingAuthority: formValue.partner_document_issuingAuthority,
        issuingAuthorityState: formValue.partner_document_issuingAuthorityState,
      },
      parentage: {
        motherName: formValue.partner_parentage_motherName,
        fatherName: formValue.partner_parentage_fatherName,
      },
      contact: {
        email: formValue.partner_contact_email,
        phone: formValue.partner_contact_phone,
      },
      address: {
        zipCode: formValue.partner_address_zipCode,
        street: formValue.partner_address_street,
        number: formValue.partner_address_number,
        complement: formValue.partner_address_complement,
        district: formValue.partner_address_district,
        city: formValue.partner_address_city,
        state: formValue.partner_address_state,
      },
      ...(isFilled(deliveryAddress) ? {deliveryAddress} : {}),
      ...(isFilled(attorneyData) ? {attorneyData} : {}),
      ...(isFilled(payment) ? {payment} : {}),
      additionalInformation: {
        hasEmployee: formValue.partner_additionalInformation_hasEmployee,
        isSellingToFamily:
        formValue.partner_additionalInformation_isSellingToFamily,
        isUnderAge:
        formValue.partner_additionalInformation_isUnderAge,
        situation:
        formValue.partner_additionalInformation_situation
      }
    }
  }
}

export function mapFormToDataPersonalSellerPfThree(formValue: any, dataPersonal: DataPersonalSellerPf): Partial<DataPersonalSellerPf> {
  const updated: Partial<DataPersonalSellerPf> = {
    ...dataPersonal,
    payment: {
      ...dataPersonal.payment,
      accountType: formValue.payment_accountType,
      bankNumber: formValue.payment_bankNumber,
      agencyNumber: formValue.payment_agencyNumber,
      accountNumber: formValue.payment_accountNumber,
    }
  };

  if (formValue.partner_payment_bankNumber && updated.partner) {
    updated.partner = {
      ...updated.partner,
      payment: {
        ...updated.partner.payment,
        accountType: formValue.partner_payment_accountType,
        bankNumber: formValue.partner_payment_bankNumber,
        agencyNumber: formValue.partner_payment_agencyNumber,
        accountNumber: formValue.partner_payment_accountNumber,
      }
    };
  }

  return updated;
}

export function emptyStringToNull(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(emptyStringToNull);
  } else if (obj !== null && typeof obj === 'object') {
    const newObj: any = {};
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      if (value === '') {
        newObj[key] = null;
      } else {
        newObj[key] = emptyStringToNull(value);
      }
    });
    return newObj;
  }
  return obj;
}

function isFilled(valueForm: Partial<any>): boolean {
  return Object.values(valueForm).some(
    v => v !== undefined && v !== null && v.toString().trim() !== ''
  );
}
